export function getOptionLabelProductTypes(option) {
    //When rendering options pass category as Others
    if (!option.category || option.category === 'Others') return 'Others'; //when user selected Others and opens in draft mode
    if (!option) return '';
    return `${option.category} > ${option.subcategory} > ${option.type}`;
}
